import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    name: "Analog Watch - For Men AS000010F",
    brand: "Allen Solly ",
    category: "Analog",
    price: 2922,
    idealFor: "Women",
    rating: 4.3,
    discountPercentage: 54,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/832/832/l19m93k0/watch/u/m/w/-original-imagcvg8qbczxz5g.jpeg?q=70",
    inStock: true,
  },
  {
    _id: uuid(),
    name: "Analog Watch - For Men LD-BK054-BLACK",
    brand: "LOUIS DEVIN",
    category: "Analog",
    price: 2199,
    idealFor: "Men",
    rating: 4.1,
    discountPercentage: 80,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/watch/k/e/l/1-ld-bk054-black-louis-devin-men-original-imagg25gzwqeawhv.jpeg?q=70",
    inStock: true,
  },
  {
    _id: uuid(),
    name: "Analog Watch - For Men AS000025E",
    brand: "Allen Solly ",
    category: "Analog",
    price: 5999,
    idealFor: "Men",
    rating: 4.2,
    discountPercentage: 66,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/832/832/ku1k4280/watch/f/4/p/1-as000025e-allen-solly-men-original-imag78zkjpdybd8g.jpeg?q=70",
    inStock: true,
  },
  {
    _id: uuid(),
    name: "Analog Watch - For Men NG38003PP13C",
    brand: "Fastrack ",
    category: "Analog",
    price: 999,
    idealFor: "Men",
    rating: 4.6,
    discountPercentage: 40,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/watch/j/l/o/-original-imagz4wvckgcz7m6.jpeg?q=70",
    inStock: true,
  },
  {
    _id: uuid(),
    name: "Minimalists Analog Watch - For Men 38024PP24",
    brand: "Fastrack ",
    category: "Analog",
    price: 850,
    idealFor: "Men",
    rating: 4.3,
    discountPercentage: 34,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/watch/w/s/d/-original-imagnqcjgxcxmfjb.jpeg?q=70",
    inStock: true,
  },
  {
    _id: uuid(),
    name: "Analog Watch - For Men TWTG80SMU18",
    brand: "TIMEX ",
    category: "Analog",
    price: 4375,
    idealFor: "Men",
    rating: 4.2,
    discountPercentage: 49,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/832/832/kzx1a4w0/watch/p/y/r/-original-imagbszbkzejtweg.jpeg?q=70",
    inStock: false,
  },
  {
    _id: uuid(),
    name: "Blue-Dial Analog Watch - For Men TW000T310",
    brand: "TIMEX ",
    category: "Analog",
    price: 4695,
    idealFor: "Men",
    rating: 2.5,
    discountPercentage: 20,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/832/832/k83dlzk0pkrrdj/watch-refurbished/p/6/g/d-tw000t310-timex-original-imafq7vnsstbztyf.jpeg?q=70",
    inStock: false,
  },
  {
    _id: uuid(),
    name: "Enticer Men's ( MTP-V005D-1BUDF ) ",
    brand: "CASIO ",
    category: "Analog",
    price: 2595,
    idealFor: "Men",
    rating: 4.3,
    discountPercentage: 30,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/832/832/krz97rk0/watch/w/e/w/a1487-casio-original-imag5n4nue9yyjtf.jpeg?q=70",
    inStock: false,
  },
  {
    _id: uuid(),
    name: "Volt Analog Watch - For Men 77085PP03",
    brand: "SONATA ",
    category: "Analog",
    price: 699,
    idealFor: "Men",
    rating: 4.8,
    discountPercentage: 4,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/watch/i/q/e/-original-imagnre8pbpnfhgz.jpeg?q=70",
    inStock: false,
  },
  {
    _id: uuid(),
    name: "Analog Watch - For Men NP77083SM01",
    brand: "SONATA ",
    category: "Analog",
    price: 1099,
    idealFor: "Men",
    rating: 4.4,
    discountPercentage: 4,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/watch/n/2/s/-original-imagz3zgk2xx5bug.jpeg?q=70",
    inStock: true,
  },
  {
    _id: uuid(),
    name: "Digital Watch - For Men",
    brand: "V2A ",
    category: "DIGITAL",
    price: 1499,
    idealFor: "Men",
    rating: 3.7,
    discountPercentage: 48,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/832/832/k4yhtow0/watch/r/a/9/stylish-popular-trendy-design-water-resistant-chronograph-v2a-original-imafnrfzgw7xhxpf.jpeg?q=70",
    inStock: false,
  },
  {
    _id: uuid(),
    name: "Digital Army Green Sports Digital Watch - For Men 800",
    brand: "EDDY HAGER ",
    category: "DIGITAL",
    price: 2599,
    idealFor: "Men",
    rating: 4.4,
    discountPercentage: 82,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/832/832/kb6tyfk0/watch/p/j/v/800-eddy-hager-original-imafshcfd7z9hhnf.jpeg?q=70",
    inStock: true,
  },
  {
    _id: uuid(),
    name: "Digital Watch - For Men ",
    brand: "PANARS  ",
    category: "DIGITAL",
    price: 999,
    idealFor: "Men",
    rating: 3.4,
    discountPercentage: 77,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/shopsy-watch/e/c/k/1-army-digital-watch-hala-men-original-imag2fx9pz7sb98k.jpeg?q=70",
    inStock: true,
  },
  {
    _id: uuid(),
    name: "Digital Watch - For Men WRG00057D",
    brand: "WROGN   ",
    category: "DIGITAL",
    price: 1999,
    idealFor: "Men",
    rating: 4.1,
    discountPercentage: 65,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/832/832/krntoy80/watch/4/q/j/wrg00057d-wrogn-original-imag5ehmdzzw2cvh.jpeg?q=70",
    inStock: true,
  },
  {
    _id: uuid(),
    name: "Water Resistance Digital Watch - For Men ",
    brand: "PANARS    ",
    category: "DIGITAL",
    price: 999,
    idealFor: "Men",
    rating: 3.5,
    discountPercentage: 78,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/832/832/kq5iykw0/watch/o/t/0/brand-a-digital-watch-with-square-led-shockproof-multi-original-imag488gbmp4665p.jpeg?q=70",
    inStock: true,
  },
  {
    _id: uuid(),
    name: "Noise Caliber Buzz Advanced Bluetooth Calling with 1.69'' display and Powerful Battery Smartwatch  (Green Strap, Regular) ",
    brand: "NOISE    ",
    category: "SMART WATCH",
    price: 4999,
    idealFor: "Men",
    rating: 4.3,
    discountPercentage: 68,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/416/416/xif0q/smartwatch/e/p/z/-original-imaghhwyh32askjq.jpeg?q=70",
    inStock: true,
  },
  {
    _id: uuid(),
    name: "Noise Caliber 2 Buzz Advanced Bluetooth Calling with 1.85'' display, Long Battery Smartwatch  (Brown Strap, Regular) ",
    brand: "NOISE    ",
    category: "SMART WATCH",
    price: 5999,
    idealFor: "Men",
    rating: 4.1,
    discountPercentage: 70,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/416/416/xif0q/smartwatch/p/b/1/-original-imagk7wsn2de3bjs.jpeg?q=70",
    inStock: false,
  },
  {
    _id: uuid(),
    name: "APPLE Watch Ultra GPS + Cellular - ECG App, Temp sensor, Blood oxygen, Fall Detection  (White Ocean Strap, Regular) ",
    brand: "APPLE    ",
    category: "SMART WATCH",
    price: 89900,
    idealFor: "Men",
    rating: 4.6,
    discountPercentage: 5,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/416/416/xif0q/smartwatch/f/w/c/-original-imaghxgpp9pczfsh.jpeg?q=70",
    inStock: true,
  },
  {
    _id: uuid(),
    name: "APPLE Watch SE GPS (2nd Gen) Heart Rate Monitor, Crash Detection, Sleep Tracking  (Midnight Strap, 40mm) ",
    brand: "APPLE    ",
    category: "SMART WATCH",
    price: 29900,
    idealFor: "Women",
    rating: 4.6,
    discountPercentage: 5,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/416/416/xif0q/smartwatch/i/1/m/-original-imaghxg3nyd3dhwp.jpeg?q=70",
    inStock: true,
  },
  {
    _id: uuid(),
    name: "APPLE Watch Series 8 GPS with ECG app, Temperature sensor, IPX6, Fall/Crash Detection  (Red Strap, Regular) ",
    brand: "APPLE    ",
    category: "SMART WATCH",
    price: 45900,
    idealFor: "Men ",
    rating: 4.5,
    discountPercentage: 5,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/416/416/xif0q/smartwatch/1/l/z/-original-imaghxh7jvztjzfa.jpeg?q=70",
    inStock: false,
  },
  {
    _id: uuid(),
    name: "boAt Wave Flex Connect with 1.83 HD Display,Bluetooth Calling & Premium Metal Design Smartwatch  (Black Strap, Free Size) ",
    brand: "BOAT    ",
    category: "SMART WATCH",
    price: 7900,
    idealFor: "Men ",
    rating: 4.1,
    discountPercentage: 79,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/416/416/xif0q/smartwatch/z/c/s/-original-imagp7vv3gwtnzhr.jpeg?q=70",
    inStock: true,
  },
  {
    _id: uuid(),
    name: "boAt Wave Neo with 1.69 inch , 2.5D Curved Display & Multiple Sports Modes Smartwatch  (Blue Strap, Free Size)",
    brand: "BOAT    ",
    category: "SMART WATCH",
    price: 5900,
    idealFor: "Men ",
    rating: 4.0,
    discountPercentage: 69,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/416/416/l3ahpjk0/smartwatch/l/n/f/-original-imagegyh8dmdxrwh.jpeg?q=70",
    inStock: true,
  },
  {
    _id: uuid(),
    name: "boAt storm Smartwatch  (Pink Strap, 1.3)",
    brand: "BOAT    ",
    category: "SMART WATCH",
    price: 5900,
    idealFor: "Women ",
    rating: 4.0,
    discountPercentage: 50,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/416/416/kyxb9u80/smartwatch/7/z/l/1-3-android-ios-storm-boat-no-original-imagbfzmemmstyfz.jpeg?q=70",
    inStock: false,
  },
  {
    _id: uuid(),
    name: "Kids Edition Spiderman Digital Watch for Kids with Disco LED / Musical sound Digital Watch - For Boys kids",
    brand: "GLENVIT-X     ",
    category: "DIGITAL",
    price: 900,
    idealFor: "Kids",
    rating: 3.0,
    discountPercentage: 76,
    warranty: "1 Year Manufacturer Warranty",
    image:
      "https://rukminim1.flixcart.com/image/832/832/kr3tj0w0/watch/s/5/y/favourite-spiderman-24-character-projector-kid-s-band-watch-red-original-imag4yr3uuyspwqk.jpeg?q=70",
    inStock: true,
  },
];
